import * as Sentry from "@sentry/react";

export const LocalStorageKeys = {
  SETTINGS: 'settings',
  VERIFIED_IN_IFRAME: 'verifiedInIframe',
} as const;
const getFromStorage = (key: string) => {
  let dataFromStorage: string | null = null;
  try {
    dataFromStorage = localStorage.getItem(key);
  } catch (e) {
    Sentry.captureException(e);
  }
  return dataFromStorage ? JSON.parse(dataFromStorage as string) : null;
}

const saveToStorage = (key: string, value: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    Sentry.captureException(e);
  }
}
const removeFromStorage = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    Sentry.captureException(e);
  }
}

export {
  getFromStorage,
  saveToStorage,
  removeFromStorage
}